import React, { useState } from "react";
import styled from "styled-components";
import ByDevice from "./SignUps/byDevice"
import ByBreakdown from "./SignUps/byBreakdown"
import ByActorType from "./SignUps/byActorType"
import ByRepresentation from "./SignUps/byRepresentation"
import BySource from "./SignUps/bySource"

function SignUpsExplorer() {
  const [searchBy, setSearchBy] = useState("dd"); // 'week' or 'dd'
  const currentDateLabel = searchBy === "dd" ? "Daily" : "Weekly";
  const inverseDateLabel = searchBy === "dd" ? "Weekly" : "Daily";

  const handleChangeTimeFrame = () => {
    setSearchBy(searchBy === "dd" ? "week" : "dd");
  };

  return (
    <Container>
      <h1>
        All Sign-ups explorer
      </h1>
      <div>
        <label>Current Time Frame:</label>&nbsp;
        <span style={{ fontSize: "1.2rem" }}>{currentDateLabel}</span> &nbsp;
        <button onClick={handleChangeTimeFrame}>Change to {inverseDateLabel}</button>
      </div>
      <br />
      
      <h2>{currentDateLabel} by Actor type</h2>
      <ByActorType date={searchBy} />
      <hr />
      <br />

      <h2>{currentDateLabel} by Representation</h2>
      <ByRepresentation date={searchBy} />
      <hr />
      <br />


      <h2>{currentDateLabel} by Breakdown</h2>
      <ByBreakdown date={searchBy} />
      <hr />

      <br />
      <h2>{currentDateLabel} by Source</h2>
      <BySource date={searchBy} />
      <hr />



    </Container>
  );
}
const Container = styled.div`
  width: 80%;
  margin:24px auto;
  .iReLkr .ReactTable * {
    text-align:left
  }
`;


export default SignUpsExplorer;